import gql from 'graphql-tag';

export const CREATE_PAYOUT = gql`
mutation createPayout($data: PayoutCreateInput!){
  createPayout(data: $data){
    id
  }
}`;